import React, { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';

const CookiePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent !== 'accepted' && consent !== 'declined') {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[99] p-4 animate-slide-up">
      <div className="glass rounded-xl p-6 max-w-4xl mx-auto shadow-2xl">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-shrink-0">
            <div className="bg-accent-secondary/20 p-3 rounded-full">
              <FaCookie className="text-accent-secondary" size={32} />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="text-white font-semibold mb-2">Nous utilisons des cookies</h3>
            <p className="text-gray-300 text-sm">
              Ce site utilise des cookies pour améliorer votre expérience, analyser le trafic et
              personnaliser le contenu. En continuant à naviguer, vous acceptez notre utilisation
              des cookies.{' '}
              <a href="/cookies" className="text-accent-primary hover:underline">
                En savoir plus
              </a>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
            <button
              onClick={handleAccept}
              className="bg-accent-primary hover:bg-accent-primary/90 text-white font-semibold py-2 px-6 rounded-lg transition-all whitespace-nowrap"
            >
              Accepter
            </button>
            <button
              onClick={handleDecline}
              className="bg-dark-card hover:bg-dark-hover text-gray-300 font-semibold py-2 px-6 rounded-lg transition-all whitespace-nowrap"
            >
              Refuser
            </button>
          </div>
          <button
            onClick={handleDecline}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            aria-label="Fermer"
          >
            <FaTimes size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;

